export default "__VITE_ASSET__6d1c1c2e__"